import FormField from 'components/FormField'
import SoftBox from 'components/SoftBox'
import SoftButton from 'components/SoftButton'
import React, { useEffect, useState } from 'react'
import { useUpdateAccount } from "queries/accounts";

function AccountTab({ formData, handleRefresh }) {
  const [success, setsuccess] = useState("")
  const [currentFormData, setcurrentFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
  });

  // Sync currentFormData with formData when formData changes
  useEffect(() => {
    if (formData) {
      setcurrentFormData(formData);
    }
  }, [formData]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setcurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setsuccess('')
  };

  const { mutateAsync: updateAccount } = useUpdateAccount(true);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      _id: currentFormData.id,
      first_name: currentFormData.first_name,
      last_name: currentFormData.last_name,
      email: currentFormData.email,
      phone_number: currentFormData.phone_number,
    };
    await updateAccount(payload);
  };
  return (
    <div>
      <p className='text-center'>{success}</p>
      <form onSubmit={handleSubmit}   >

        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", padding: "10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">First Name</label>
              <input className='form-control-agust' onChange={handleChange} placeholder="Name" name="first_name" value={currentFormData.first_name}
              />
            </SoftBox>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Last Name</label>
              <input className='form-control-agust' onChange={handleChange} placeholder="Name" name="last_name" value={currentFormData.last_name}
              />
            </SoftBox>
          </div>
          <div style={{ width: "50%", padding: "10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Email Address</label>
              <input className='form-control-agust' onChange={handleChange} placeholder="Email" name="email" value={currentFormData.email}
              />
            </SoftBox>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Phone Number</label>
              <input className='form-control-agust' onChange={handleChange} placeholder="Phone number" name="phone_number" value={currentFormData.phone_number}
              />
            </SoftBox>
          </div>
        </div>


        <div style={{ margin: "10px 0px", textAlign: "right" }}>
          <SoftButton type="submit" color="dark">
            update
          </SoftButton>
        </div>
      </form>
    </div>
  )
}

export default AccountTab
